import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../state/auth';
import { useT } from '../i18n';

export default function Register() {
  const t = useT();
  const { register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nameAr, setNameAr] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await register(email, password, nameAr);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-form form-zone" onSubmit={handleSubmit}>
        <h2 className="zone-title">{t.register}</h2>

        {error && <p className="auth-error">{error}</p>}

        <label className="field">
          <span className="field-label">{t.registerNameLabel}</span>
          <input type="text" value={nameAr} onChange={(e) => setNameAr(e.target.value)} />
        </label>

        <label className="field">
          <span className="field-label">{t.email}</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>

        <label className="field">
          <span className="field-label">{t.password}</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>

        <button type="submit" className="submit-btn" disabled={busy}>
          {t.registerBtn}
        </button>

        <p className="auth-switch">
          {t.hasAccount} <Link to="/login">{t.login}</Link>
        </p>
      </form>
    </div>
  );
}
